<template>
  <TemplateDetails :get-function="loadSeller" :data="seller" :loading="sellerLoading">
    <template v-if="seller">
      <PageBack :to="listRoute" />
      <PageHeader :title="$t('store-sellers.edit.title')" />

      <StoreSellerForm edit :model="seller" :show-header="false" />

      <div class="store-seller-edit__actions">
      <ButtonLink
        size="m"
        color="red"
        icon="delete"
        :to="deleteRoute"
      >
        {{ $t('store-sellers.delete.link') }}
      </ButtonLink>
    </div>

    <section class="store-seller-password">
      <PageHeader :title="$t('store-sellers.password.title')" />
      <form @submit.prevent="resetPassword">
        <Field
          :model="password"
          name="password"
          type="password"
          :label="`${$t('global.password')} *`"
          required
          @change="(e) => (password = e)"
        />
        <ButtonForm :disabled="!password" :loading="passwordLoading">{{
          $t('store-sellers.password.submit')
        }}</ButtonForm>
      </form>
      <PopinNotification ref="passwordSuccess" :text="$t('store-sellers.password.success')" />
      <PopinNotification ref="passwordError" :text="$t('store-sellers.password.error')" />
    </section>
    </template>
  </TemplateDetails>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TemplateDetails from '@/components/templates/TemplateDetails';
import StoreSellerForm from '@/components/ui/store-seller/StoreSellerForm';
import PageBack from '@/components/ui/page/PageBack';
import PageHeader from '@/components/ui/page/PageHeader';
import Field from '@/components/ui/form/fields/Field';
import ButtonForm from '@/components/ui/button/ButtonForm';
import PopinNotification from '@/components/ui/popin/PopinNotification';
import ButtonLink from '@/components/ui/button/ButtonLink';
import {
  sellerIdFromRoute,
  storeSellerDeleteRoute,
  storeSellerListRoute,
} from '@/utils/store-seller-routes';

export default {
  name: 'StoreSellerEdit',
  components: {
    ButtonLink,
    PopinNotification,
    ButtonForm,
    Field,
    PageBack,
    PageHeader,
    StoreSellerForm,
    TemplateDetails,
  },
  data() {
    return {
      password: null,
      passwordLoading: false,
    };
  },
  computed: {
    ...mapState(['seller', 'sellerLoading']),
    sellerId() {
      return sellerIdFromRoute(this.$route);
    },
    listRoute() {
      return storeSellerListRoute(this.$route.params.id);
    },
    deleteRoute() {
      return storeSellerDeleteRoute(this.$route.params.id, this.sellerId);
    },
  },
  methods: {
    ...mapActions(['fetchSeller', 'resetSellerPassword']),
    loadSeller() {
      return this.fetchSeller(this.sellerId);
    },
    async resetPassword() {
      this.passwordLoading = true;
      try {
        await this.resetSellerPassword({
          id: this.sellerId,
          password: this.password,
        });
        this.password = null;
        this.$refs.passwordSuccess.open();
      } catch {
        this.$refs.passwordError.open();
      } finally {
        this.passwordLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.store-seller-edit__actions {
  margin: 24px 0;
}

.store-seller-password {
  margin-top: 40px;
  padding-bottom: 120px;
}
</style>
